module.exports = __webpack_public_path__ + "static/media/Free.f777688a.webp";